
/**
 * @export
 * @enum {string}
 */
export enum UserLayoutType {
    TABLE = 'TABLE',
    PIVOT_TABLE = 'PIVOT_TABLE'
}